<div class="form-content-item">
  <form [formGroup]="form" (keydown.enter)="$event.stopPropagation()">
    <div>
      <div class="consult-emails">
        <h3 class="title-margin-top">{{ 'email_recipient_selection' | translate }}</h3>
        <mat-card>
          <mat-checkbox formControlName="allUsers" color="primary">{{ 'email_send_to_all_users' | translate }} ({{ allRecipients.length }})</mat-checkbox>
          <div class="row recipients-picker" *ngIf="!formCtls.allUsers.value">
            <div class="col-3">
              <mat-form-field>
                <mat-label>{{ 'email_filter_by_profile' | translate }}</mat-label>
                <mat-select formControlName="profile" (selectionChange)="applyFilters()">
                  <mat-option [value]="null">{{ 'email_all_profiles' | translate }}</mat-option>
                  <mat-option *ngFor="let f of profilesFilter" [value]="f.value">{{ f.label }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'email_search_recipient' | translate }}</mat-label>
                <input matInput [(ngModel)]="search" [ngModelOptions]="{ standalone: true }" (ngModelChange)="applyFilters()" />
              </mat-form-field>
            </div>
            <div class="col-9">
              <div class="recipients-header">
                <mat-checkbox color="primary" [checked]="allVisibleSelected" [indeterminate]="someVisibleSelected" [disabled]="visibleRecipients.length === 0" (change)="toggleVisible($event.checked)">
                  {{ (formCtls.profile.value ? 'email_select_all_profile' : 'email_select_all') | translate: { profile: formCtls.profile.value } }}
                </mat-checkbox>
                <span class="recipients-count">{{ 'email_selected_count' | translate: { count: selectedEmails.size } }}</span>
              </div>
              <cdk-virtual-scroll-viewport itemSize="36" class="recipients-list">
                <div *cdkVirtualFor="let r of visibleRecipients" class="recipient-row">
                  <mat-checkbox color="primary" [checked]="selectedEmails.has(r.email!)" (change)="toggleRecipient(r.email!, $event.checked)">
                    {{ r.firstName }} {{ r.lastName }} - [{{ r.profilCode }}] <span class="recipient-email">{{ r.email }}</span>
                  </mat-checkbox>
                </div>
              </cdk-virtual-scroll-viewport>
              <mat-error *ngIf="submitted && selectedEmails.size === 0">{{ 'email_error_recipients_required' | translate }}</mat-error>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col">
              <button class="btn-margin-right align-right" mat-raised-button color="primary" type="button" [disabled]="!canExportCsv" (click)="exportUsersMails()">{{ 'email_export_selected' | translate }}</button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <div class="envoi-email">
      <h3 class="title-margin-top">{{ 'email_send_section' | translate }}</h3>
      <mat-card>
        <div class="row">
          <div class="col-3">
            <mat-form-field>
              <mat-label color="accent">{{ 'email_reply_to' | translate }}</mat-label>
              <input matInput formControlName="sender" required />
              <mat-error *ngIf="submitted && formCtls.sender.invalid">{{ 'email_error_reply_to_required' | translate }}</mat-error>
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field>
              <mat-label color="accent">{{ 'email_subject' | translate }}</mat-label>
              <input matInput formControlName="subject" required />
              <mat-error *ngIf="submitted && formCtls.subject.invalid">{{ 'email_error_subject_required' | translate }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <angular-editor formControlName="mailContent" [config]="htmlEditorConfig" required> </angular-editor>
            <mat-error *ngIf="submitted && formCtls.mailContent.invalid">{{ 'email_error_content_required' | translate }}</mat-error>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <button class="btn-margin-right" mat-raised-button color="primary" type="submit" (click)="sendMail()">{{ 'email_send' | translate }}</button>
          </div>
        </div>
      </mat-card>
    </div>
    <div class="other-actions">
      <h3 class="title-margin-top">{{ 'email_other_actions' | translate }}</h3>
      <mat-card>
        <div class="row">
          <div class="col">
            <button class="btn-margin-right" mat-raised-button color="primary" (click)="getEmails()">{{ 'email_check_status' | translate }}</button>
          </div>
        </div>
      </mat-card>
    </div>
  </form>
</div>
